// extracted by mini-css-extract-plugin
export default {"bar":"TabBar_bar__o3cXG","tab":"TabBar_tab__lFPWc","tabAtivo":"TabBar_tabAtivo__-Mg5E","icon":"TabBar_icon__pnv3N","label":"TabBar_label__u8SjY","close":"TabBar_close__Grs8B"};